import { useEffect } from 'react';
import { Trans } from '@lingui/macro';
import { ActionIcon, Button, Flex, Group, Stack } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { Bell } from 'tabler-icons-react';

import { SwitchLang } from '../../components/switch-lang/switch-lang';
import { UiCard } from '../../components/ui/ui-card/ui-card';
import { authStore } from '../../domains/auth/auth.store';
import { AvailableRoutes } from '../../domains/available-routes/features/available-routes/available-routes';
import { useOrders } from '../../domains/cabinet/features/orders/orders.provider';
import { useOrdersFeedback } from '../../domains/feedback/feedback-orders.store';
import { useProfile } from '../../domains/profile/use-profile';
import { PushNotifyAccessRequest } from '../../domains/push-notify/push-notify-access-request';
import { MainSideMenu } from '../../features/main-side-menu/main-side-menu';
import { routeCabinet, routeSignIn, routeSignUp } from '../../router/routes';

import styles from './main.page.module.css';

const NotificationCounter = observer(() => {
  const { ordersStore } = useOrders();
  const feedbackOrders = useOrdersFeedback({ ordersStore });
  const waitingFeedback = feedbackOrders.feedbackOrders.get().waitingFeedback;
  const waitingFeedbackCount = waitingFeedback.length;
  const maxFeedbackCount = waitingFeedbackCount > 9 ? 9 : waitingFeedbackCount;
  const navigate = useNavigate();

  const navigateToNotificationCenter = () => {
    const notificationCenterPath = routeCabinet.REVIEWS.path;
    navigate(notificationCenterPath);
  };

  return !authStore.hasAuth ? null : (
    <ActionIcon
      variant="transparent"
      pos="relative"
      onClick={navigateToNotificationCenter}
    >
      <Bell color="white" size={19} />

      {maxFeedbackCount > 0 ? (
        <div className={styles.notificationCounter}>{maxFeedbackCount}</div>
      ) : null}
    </ActionIcon>
  );
});

export const MainPage = observer(() => {
  const navigate = useNavigate();
  const { profile } = useProfile();
  const { getOrdersRequest } = useOrders();

  useEffect(() => {
    if (!authStore.hasAuth) return;

    getOrdersRequest.send();
  }, [getOrdersRequest]);

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.topPanel}>
          {authStore.hasAuth && (
            <Flex gap={8}>
              <span
                className={styles.profileLogin}
                onClick={() => navigate(routeCabinet.path)}
              >
                {profile?.login}
              </span>
            </Flex>
          )}

          <div className={styles.navMenu}>
            <Group>
              {authStore.hasAuth && <NotificationCounter />}

              <MainSideMenu variant="transparent" iconColor="white" />
            </Group>
          </div>
        </div>

        <h1 className={styles.headerTitle}>
          <Trans>Электрички Армении</Trans>
        </h1>
      </header>

      <main className={styles.main}>
        <Stack spacing="sm">
          <AvailableRoutes />

          {authStore.hasAuth && <PushNotifyAccessRequest />}

          {!authStore.hasAuth && (
            <UiCard>
              <Stack spacing="xs">
                <Button
                  variant="outline"
                  size="md"
                  onClick={() => navigate(routeSignUp.path)}
                >
                  <Trans>Регистрация</Trans>
                </Button>
                <Button size="md" onClick={() => navigate(routeSignIn.path)}>
                  <Trans>Вход</Trans>
                </Button>
              </Stack>
            </UiCard>
          )}

          <UiCard title={<Trans>Выбор языка</Trans>}>
            <SwitchLang />
          </UiCard>
        </Stack>
      </main>
    </div>
  );
});
